// Static content for Solving365 consultancy platform

export const queryTypes = [
  { value: 'Problem', label: 'Problem - Technical issue resolution' },
  { value: 'Advise', label: 'Advise - Strategic guidance' },
  { value: 'Scripting', label: 'Scripting - Custom automation scripts' }
];

export const pricingPlans = [
  {
    id: 'free',
    name: 'Free First Query',
    price: 0,
    description: 'Try our service with your first query completely free',
    sla: '24 hours',
    features: [
      'Full technical consultation',
      'Email or Teams meeting response',
      'One-time query resolution',
      'Expert Microsoft 365 advice',
      '24-hour response guarantee'
    ],
    buttonText: 'Get Started Free',
    highlighted: false
  },
  {
    id: 'standard',
    name: 'Standard Query',
    price: 100,
    description: 'Professional support for your Microsoft 365 needs',
    sla: '24 hours',
    features: [
      'Comprehensive problem analysis',
      'Detailed solution documentation',
      'Email and Teams meeting support',
      'Follow-up assistance included',
      'Priority email support'
    ],
    buttonText: 'Submit Query',
    highlighted: true
  },
  {
    id: 'priority',
    name: 'Priority Query',
    price: 200,
    description: 'Urgent matters requiring immediate attention',
    sla: '1 hour',
    features: [
      'Immediate response within 1 hour',
      'Critical issue resolution',
      'Direct Teams meeting available',
      'After-hours support included',
      'Dedicated priority handling'
    ],
    buttonText: 'Get Priority Support',
    highlighted: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Jennifer Adams',
    company: 'Healthcare Solutions Inc',
    role: 'IT Director',
    content: 'Kaustubh resolved our complex Exchange Online migration issues within hours. His deep knowledge of Microsoft 365 saved us weeks of troubleshooting.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150'
  },
  {
    id: 2,
    name: 'David Martinez',
    company: 'Tech Innovators Ltd',
    role: 'CTO',
    content: 'The Azure AD integration guidance was spot-on. Professional, timely, and exactly what we needed for our security compliance requirements.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150'
  },
  {
    id: 3,
    name: 'Emily Watson',
    company: 'Digital Marketing Agency',
    role: 'Operations Manager',
    content: 'Excellent PowerShell automation scripts that streamlined our user management. Worth every penny for the time saved.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150'
  }
];

export const faqs = [
  {
    question: 'How does the free first query work?',
    answer: 'When you register on our platform, you can submit your first query completely free. You\'ll receive the same professional service with our standard 24-hour SLA response time.'
  },
  {
    question: 'What qualifications do you have?',
    answer: 'I have extensive experience managing Microsoft 365 environments, including a large tenant with 20,000 E5 licenses. I\'ve worked as a Microsoft support engineer and team lead, handling complex Exchange Online, SharePoint, Teams, and Azure AD issues.'
  },
  {
    question: 'What does the 24-hour SLA mean?',
    answer: 'Our 24-hour SLA guarantees you\'ll receive an initial response within 24 hours of query submission. For priority queries, this is reduced to just 1 hour.'
  },
  {
    question: 'How are responses delivered?',
    answer: 'Responses are delivered via email with detailed documentation. For complex issues, we schedule a Microsoft Teams meeting to walk through the solution together.'
  },
  {
    question: 'Can I purchase multiple queries at once?',
    answer: 'Yes! You can purchase query credits in advance. Contact us for package pricing and volume discounts.'
  },
  {
    question: 'What types of issues can you help with?',
    answer: 'We specialize in Microsoft 365 and Azure AD issues including Exchange Online, SharePoint, Teams, OneDrive, tenant administration, migrations, security configurations, and custom PowerShell scripting.'
  },
  {
    question: 'Do you offer refunds?',
    answer: 'If we\'re unable to provide a satisfactory resolution to your query, we offer a full refund - no questions asked.'
  },
  {
    question: 'Is my data secure?',
    answer: 'Absolutely. We follow strict confidentiality protocols and never share your information or query details with third parties. All communications are encrypted.'
  }
];
